import { render, staticRenderFns } from "./HomeMetrics.vue?vue&type=template&id=34702812"
import script from "./HomeMetrics.vue?vue&type=script&lang=js"
export * from "./HomeMetrics.vue?vue&type=script&lang=js"
import style0 from "./HomeMetrics.vue?vue&type=style&index=0&id=34702812&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports